<template>
	<div class="Milestone">
		<div class="Milestone-top">
			<img
				:src="require('@/assets/images/milestone-top.png')"
				class="image-width"
				alt=""
			/>
		</div>
		<div class="Milestone-mid">
			<div class="Milestone-mid-img">
				<img
					:src="require('@/assets/images/milestone-mid.png')"
					class="image-width"
					alt=""
				/>
			</div>
			<div class="Milestone-mid-text">{{ $t('里程碑') }}</div>
		</div>
		<div class="Milestone-title">
			{{ $t('科技创新、诚信服务、持续改进、满足用户') }}
		</div>
		<div class="Milestone-text">
			{{
				$t(
					'三环集团秉持“科技创新、诚信服务、持续改进、满足用户”的质量管理理念，建立了完整的产品质量控制体系。全过程质量控制和持续改进提升了产品质量水平，主要产品取得了ISO9001质量管理体系认证、IATF16949汽车行业质量管理体系认证、ISO14001环境管理体系认证、国际IECQ认证、美国UL认证，产品进入全球采购链，深受用户认可。'
				)
			}}
		</div>
		<div class="Milestone-timecon">
			<div
				class="Milestone-timecon-item"
				v-for="(item, index) in milestonelist"
				:key="index"
			>
				<div class="timecon-item-img">
					{{ getLangText(item, 'name') }}
				</div>
				<div class="timecon-item-textbox">
					<div class="item-textbox-text">
						<div class="textbox-text-inside">
							<div class="textbox-text-con">
								{{ getLangText(item, 'brief') }}
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { getMilepostList } from '@/api';

export default {
	data() {
		return {
			milestonelist: []
		};
	},
	created() {
		this.frontListFZ();
	},
	methods: {
		//里程碑接口
		frontListFZ() {
			getMilepostList().then(res => {
				this.milestonelist = res.list;
			});
		}
	}
};
</script>

<style lang="scss">
@use './Milestone.scss';
</style>
